$('.cover2').on('click', function () {         
    $(this).children().css({
        'z-index' : 1,
        'opacity': 1
    });
    $(this).children().trigger('play');
});

$('.tabbtn').click(function(){
    $(this).removeClass('active show')
})

new Swiper('.dateTimeAppintment', {
    spaceBetween: 0,
    navigation: {
        nextEl: '.swiper-button-next-date',
        prevEl: '.swiper-button-prev-date',
    },
    breakpoints: {
        990: {
            slidesPerView: 1,
            slidesPerGroup: 1
        }
    },
}); 

if ($(window).width() >= 992) {
$('#play-video').on('click', function(ev) {
    $("#video")[0].src += "&autoplay=1";
        ev.preventDefault();
});
}

var player; 
function onYouTubeIframeAPIReady() {
    player = new YT.Player('video', {
        events: {
            'onReady': onPlayerReady
        }
    });
}

function onPlayerReady(event) {
    var playButton = document.getElementById('play-video');
    playButton.addEventListener('click', function() {
        event.target.playVideo();
    });
}

// Load the IFrame Player API code asynchronously.
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

$('#play-video1').on('click', function(ev) {
     $("#video1")[0].src += "&autoplay=1";
        ev.preventDefault();
});
$('.coverNew').on('click', function(ev) {
    $(this).addClass('hidevideo');
});

$('.viewList').click(function(){
    $('#viewList').show()
    $(this).addClass('active');
    $('.viewMap').removeClass('active');
    $('#viewMap').hide()
});

$('.viewMap').click(function(){
    $('#viewList').hide()
    $(this).addClass('active')
    $('.viewList').removeClass('active');
    $('#viewMap').show()
})

function loadMoreProduct(collectionId, usedClassName, totalProducts, basePath){
    var start = parseInt($("." + usedClassName + ":last").attr("id"));
    var totalProducts = totalProducts;

    dataString = 'collection_id=' + collectionId ;

    if (start != '') { dataString += '&start=' + start; }

    requestObj = 
    $.ajax({
        type: "GET",
        url: basePath+'collection_product_ajax.php',
        data: dataString,
        cache: false,
        success: function (responseStr) {
            //alert(responseStr);
            //$('#workingDiv').hide();

            //document.getElementById(mainDivId).style.background = 'none';
            //document.getElementById(mainDivId).style.opacity = 1.00;
            //document.getElementById(mainDivId).style.filter = 'alpha(opacity=' + 100 + ')';

            if (responseStr != "") {
                $("." + usedClassName + ":last").after(responseStr);
            }
        }
    });    
}

function loadMoreAccessoriesProduct(collectionId, usedClassName, totalProducts, basePath){
    var start = parseInt($("." + usedClassName + ":last").attr("id"));
    var totalProducts = totalProducts;

    dataString = 'collection_id=' + collectionId ;

    if (start != '') { dataString += '&start=' + start; }

    requestObj = 
    $.ajax({
        type: "GET",
        url: basePath+'collection_accessories_product_ajax.php',
        data: dataString,
        cache: false,
        success: function (responseStr) {
            if (responseStr != "") {
                $("." + usedClassName + ":last").after(responseStr);
            }
        }
    });    
}

function getStroreAddress(obj) {
    var storeCity = obj.value;
    if(storeCity == 'Artesia'){
        $('#fldStoreAddress').html('<option value="">Please select an address</option><option selected="selected" value="18508 Pioneer Blvd, Artesia, California 90701, United States">18508 Pioneer Blvd, Artesia, California 90701, United States</option>');
    }
    if(storeCity == 'Glendale'){
        $('#fldStoreAddress').html('<option value="">Please select an address</option><option selected="selected" value="519 Americana Way, Glendale, California 91210, United States">519 Americana Way, Glendale, California 91210, United States</option>');
    }
}

// function getStroreAddress(obj, basePath) {
//     var storeCity = $.trim($(obj).val());
//     $('#fldStoreAddress').html('<option value="">Please select an address</option>');

//     if(storeCity) {

//         dataString = 'storeCity=' + storeCity ;

//         $.ajax({
//             type: "POST",
//             url: basePath+'getStroreAddress.php',
//             data: dataString,
//             cache: false,
//             success: function (responseStr) {
//                 $('#fldStoreAddress').html(responseStr);
//             }
//         });
//     }
// }

function getStoreTiming(week, basePath, year='', Env='') {
    
    var storeID = $("input[name='apptLocation']:checked").attr('data-store-id');
    dataString = 'week=' + week + '&storeID=' + storeID + '&year=' + year;
    //var dataString = '';
    
    const spinner = document.getElementById('loadingSpinnerCal');
    spinner.classList.remove('d-none');
    
    var actionURL = basePath+'getStoreTiming.php';
    if(Env == 'Dev') {
        var actionURL = basePath+'getStoreTimingDev.php';
    }
    
    $.ajax({
        type: "POST",
        url: actionURL,
        data: dataString,
        cache: false,
        success: function (responseStr) {
            
            var responseArr = responseStr.split('~~');
            $('#storeTimingContainer').html(responseArr[0]);

            $('#weekDaysRange').html(responseArr[1]);
            $('#formTimeFocus').focus();
            
            var selectedDate = $("input[name='apptDate']:checked").val();
            loadTimeSlots(selectedDate, basePath, Env);
            
            // Hide spinner
            spinner.classList.add('d-none');
        }
    });
}

function loadTimeSlots(selectedDate, basePath, Env='') {
    
    var storeID = $("input[name='apptLocation']:checked").attr('data-store-id');
    dataString = 'selectedDate=' + selectedDate + '&storeID=' + storeID;
    //var dataString = '';
    
    const spinner = document.getElementById('loadingSpinnerCal');
    spinner.classList.remove('d-none');
    
    $('#timeSlotContainer').html(''); 
    
    var actionURL = basePath+'getAvailableTimeSlot.php';
    if(Env == 'Dev') {
        var actionURL = basePath+'getAvailableTimeSlotDev.php';
    }
    
    $.ajax({
        type: "POST",
        url: actionURL,
        data: dataString,
        cache: false,
        success: function (responseStr) {
            
            var responseArr = responseStr.split('~~');
            //alert(responseArr[0]);
            
            if (responseArr[0] == 0) {
                $('#timeSlotContainer').html(responseArr[1]); 
            } else {
                $('#timeSlotContainer').html('<div class="noAvialabilityClass fixed-16 w-100 text-center">'+responseArr[1]+'</div>'); 
                //alert(responseArr[1]);
            }
            
            // Hide spinner
            spinner.classList.add('d-none');            
        }
    });
}

function showSavedApptDetail() {
    var apptLocation = $("input[name='apptLocation']:checked").val();
    var apptPurpose = $("input[name='apptPurpose']:checked").val();
    
    $('#apptPurposeText').html(apptPurpose);
    $('#apptLocationText').html(apptLocation);
}

$(document).ready(function() {
    $("input[name='apptPurpose']").click(function() {
        
        $('.rolexConsentClass').hide();
        
        if ($(this).is(':checked')) {
            var apptFor = $("input[name='apptPurpose']:checked").attr('data-attr');
            //alert(apptFor);
            
            if(apptFor == 'RW') {
                $('.rolexWatchConsent').show();
            }else {
                $('.rolexServiceConsent').show();
            }
            $("html, body").animate({ scrollTop: 400 }, "slow");
        }
    });
});

function validateSelectedDateTime(basePath) {
    var apptDate = $("input[name='apptDate']:checked").val();
    var apptTime = $("input[name='apptTime']:checked").val();
    
    if (apptDate && apptTime) {
        $('#validateDateTimeID').trigger('click');
        var validate = true;
    } else {
        alert("Please select both a date and a time before proceeding.");
        var validate = false;
    }
    
    if(validate) {
        var storeID = $("input[name='apptLocation']:checked").attr('data-store-id');
        
        var apptPurpose = $("input[name='apptPurpose']:checked").data('appt-value');
        var apptDate = $("input[name='apptDate']:checked").val();
        var apptTime = $("input[name='apptTime']:checked").val();
        
        dataString = 'storeID=' + storeID + '&apptPurpose=' + apptPurpose +  '&apptDate=' + apptDate +  '&apptTime=' + apptTime + '&actionFrom=appointment';
        //var dataString = '';
        
        const spinner = document.getElementById('loadingSpinnerForm');
        spinner.classList.remove('d-none');
                        
        $.ajax({
            type: "POST",
            url: basePath+'getStroreAddress.php',
            data: dataString,
            cache: false,
            success: function (responseStr) {
                
                var responseArr = responseStr.split('~~');
                //alert(responseArr[0]);
                
                $('#fldStoreCity').html(responseArr[0]); 
                $('#fldStoreAddress').html(responseArr[1]);     
                $('#appointmentInformation').val(responseArr[2]);     
                    
                // Hide spinner
                spinner.classList.add('d-none');    
                $('#fldFirstName').focus();
            }
        });
    }
}

function saveApptDetail(basePath, Env='') {
    var basePathApi = "https://shopify-admin.bluestar-apps.com/bhindi/api/";
    var basePathRedirect = "https://bhindi-jewelers.myshopify.com/pages/";
        
    var apptPurpose = $("input[name='apptPurpose']:checked").val();    
    var apptLocation = $("input[name='apptLocation']:checked").val();
    
    var apptDate = $("input[name='apptDate']:checked").val();
    var apptTime = $("input[name='apptTime']:checked").val();
    
    var appointmentInformation = $.trim($('#appointmentInformation').val());
    //alert(appointmentInformation);
    
    var storeID = $("input[name='apptLocation']:checked").attr('data-store-id');

    validate = true;
    errorCount = 0;
    
    var ctfldSex = $.trim($('#fldSex').val());
    var ctFirstName = $.trim($('#fldFirstName').val());
    var ctLastName = $.trim($('#fldLastName').val());
    var ctEmail = $.trim($('#fldEmail').val());
    var ctStdCode = $.trim($('#fldStdCode').val());
    var ctPhone = $.trim($('#fldPhone').val());
    
    var customerCountry = $.trim($('#fldCountryResidense').val());
    var apptCommuntionMethod = $("input[name='apptCommuntionMethod']:checked").val() || '';
    var apptComment = $.trim($('#apptComment').val());
    
    var apptToken = $.trim($('#apptToken').val());
    
    var ctCheckPolicy = $("input[name='fldCheckPolicy']:checked").val();
    var ctCheckConsent = $("input[name='fldUserConsent']:checked").val();
        
    $('.requiredField').each(function() {
        value = $.trim($(this).val());
        fldID = $(this).attr('id');
        fldDivClass = fldID+'-class';

        if(value == '') {
            errorCount++;
            $('.'+fldDivClass).addClass('msgYes');
        }else {
            $('.'+fldDivClass).removeClass('msgYes');
        }
    });

     if (ctEmail === '' || ctPhone === '') {
        // Show error if either field is empty
        if (ctEmail === '') {
            $(".fldEmail-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldEmail-class").removeClass('msgYes');
        }

        if (ctPhone === '') {
            $(".fldPhone-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldPhone-class").removeClass('msgYes');
        }
    } else {
        // Validate email format
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!emailRegex.test(ctEmail.trim())) {
            $(".fldEmail-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldEmail-class").removeClass('msgYes');
        }

        // Validate phone format
        let phoneRegex = /^[0-9]{3}-?[0-9]{3}-?[0-9]{4}$/;
        if (!phoneRegex.test(ctPhone.trim())) {
            $(".fldPhone-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldPhone-class").removeClass('msgYes');
        }
    }
    
    // Privacy Policy
    if (!ctCheckPolicy) {                
        $('.policyClass').show();
        $('#fldCheckPolicy').focus();
        errorCount++;
    }else {
        $('.policyClass').hide();
    }
    
    // User Consent
    if (!ctCheckConsent) {                
        $('.consentClass').show();
        $('#fldUserConsent').focus();
        errorCount++;
    }else {
        $('.consentClass').hide();
    }
    
    if(errorCount == 0) {
        validate = true;
    }else {
        validate = false;
    }

    if(validate == false) return false;
    
    // Set default values after validation
    ctCheckPolicy = $("input[name='fldCheckPolicy']").is(":checked") ? "Yes" : "No";
    ctCheckConsent = $("input[name='fldUserConsent']").is(":checked") ? "Yes" : "No";
    
    var dataString = 'ctfldSex='+ ctfldSex + '&ctFirstName='+ ctFirstName + '&ctLastName='+ ctLastName + '&ctEmail='+ ctEmail + '&ctStdCode='+ ctStdCode + '&ctPhone='+ ctPhone + '&apptPurpose='+ encodeURI(apptPurpose) + '&apptLocation='+ encodeURI(apptLocation) + '&apptDate='+ encodeURI(apptDate) + '&apptTime='+ encodeURI(apptTime) + '&apptComment='+ encodeURI(apptComment) + '&apptCommuntionMethod='+ encodeURI(apptCommuntionMethod) + '&customerCountry='+ encodeURI(customerCountry) + '&ctCheckPolicy=' + ctCheckPolicy + '&ctCheckConsent=' + ctCheckConsent + '&storeID=' + storeID + '&apptToken=' + apptToken + '&actionFrom=saveAppt';
    
    
    let actionURL = basePathApi+'send-appointment-email.php';
    let apptPageURL = basePathRedirect+'book-an-appointment.html';
    
    if(Env == 'Dev') {
        actionURL = basePathApi+'send-appointment-email-dev.php';
        apptPageURL = basePathRedirect+'book-an-appointment-dev.html';
    }
    
    // Modify appointment: validate token before sending request
    if (apptToken !== '') {
        validateApptToken(apptToken, actionURL).then(function(isValidApptAction) {
            if (!isValidApptAction) {
                window.location.href = apptPageURL;
                return;
            }
            sendAppointmentRequest(dataString, actionURL, appointmentInformation);
        });
    } else {
        // New appointment: send request directly
        sendAppointmentRequest(dataString, actionURL, appointmentInformation);
    }
}

function sendAppointmentRequest(dataString, actionURL, appointmentInformation) {
    
    const spinner = document.getElementById('loadingSpinnerForm');
    //spinner.classList.remove('d-none');
    
    $.ajax({
        type: "POST",
        url: actionURL,
        data: dataString,
        cache: false,
        success: function(responseStr){
            var responseArr = responseStr.split('~~');
            
            // Hide spinner
            spinner.classList.add('d-none');
            
            if(responseArr[0] == 1) {
                $('#apptDateText').html(responseArr[1]);
                showSavedApptDetail();
                
                $('#modifyApptLink').attr('href', responseArr[2]);
                
                $('.gotoThankyouBtn').trigger('click');
                $('#appointmentForm').trigger('reset');
                
                scollToDiv('bookAnappointment', 700);
                
                // Tracking
                window.appointmentInformation = appointmentInformation;
                if(apptToken && responseArr[3] == 0) {
                    _satellite.track('modifyAppointment');
                }else {
                    _satellite.track('bookAppointment');
                }
                
                // Debugging: Log the value to check
                console.log("Tracked appointmentInformation:", window.appointmentInformation);
            }else {
                alert('Something went wrong!! Please try again.');
                return false;
            }
        }
    });
}

function validateApptToken(apptToken, actionURL) {
    const dataString = 'apptToken=' + apptToken + '&actionFrom=validateToken';

    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url: actionURL,
            data: dataString,
            cache: false,
            success: function(responseStr) {
                const [apptStatus, apptMessage] = responseStr.split('~~');
                //alert(apptStatus);
                if (apptStatus == 1) {
                    resolve(true);
                } else {
                    alert(apptMessage);
                    resolve(false);
                }
            },
            error: function() {
                alert('Something went wrong during token validation.');
                resolve(false);
            }
        });
    });
}


function validateContact(actionFrom = '') {

    var ctpageOrigin = document.contactForm.pageOrigin.value;
    var ctfldSex = document.contactForm.fldSex.value.trim();
    var ctFirstName = document.contactForm.fldFirstName.value.trim();
    var ctLastName = document.contactForm.fldLastName.value.trim();
    var ctEmail = document.contactForm.fldEmail.value.trim();
    var ctStdCode = document.contactForm.fldStdCode.value.trim();
    var ctPhone = document.contactForm.fldPhone.value.trim();
    var ctMessage = document.contactForm.fldMessage.value.trim();

    var fldCountryResidense = document.contactForm.fldCountryResidense.value.trim();
    var fldStoreCountry = document.contactForm.fldStoreCountry.value.trim();
    var fldStoreCity = document.contactForm.fldStoreCity.value.trim();
    var ctStoreAddress = document.contactForm.fldStoreAddress.value.trim();
    var storeID = $('#fldStoreAddress option:selected').attr('data-store-id') || '';

    var ctCheckPolicy = document.contactForm.fldCheckPolicy.checked;
    var ctCheckConsent = document.contactForm.fldUserConsent.checked;

    var validate = true;
    var errorCount = 0;

    $('.requiredField').each(function() {

        var value = $.trim($(this).val());
        var fldID = $(this).attr('id');
        var fldDivClass = fldID + '-class';

        if (value == '') {
            errorCount++;
            $('.' + fldDivClass).addClass('msgYes');
        } else {
            $('.' + fldDivClass).removeClass('msgYes');
        }
    });


    /* Email validation */
    if (ctEmail === '') {

        $(".fldEmail-class").addClass('msgYes');

    } else {

        var emailRegex =
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!emailRegex.test(ctEmail)) {
            $(".fldEmail-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldEmail-class").removeClass('msgYes');
        }
    }


    /* Phone validation */
    if (ctPhone === '') {

        $(".fldPhone-class").addClass('msgYes');

    } else {

        var phoneRegex = /^[0-9()\-\s]+$/;

        if (!phoneRegex.test(ctPhone)) {
            $(".fldPhone-class").addClass('msgYes');
            errorCount++;
        } else {
            $(".fldPhone-class").removeClass('msgYes');
        }
    }


    /* Privacy Policy */
    if (!ctCheckPolicy) {

        $('.policyClass').show();
        document.contactForm.fldCheckPolicy.focus();
        errorCount++;

    } else {

        $('.policyClass').hide();
    }


    /* User Consent */
    if (!ctCheckConsent) {

        $('.consentClass').show();
        document.contactForm.fldUserConsent.focus();
        errorCount++;

    } else {

        $('.consentClass').hide();
    }


    if (errorCount > 0) {
        return false;
    }


    /* ==========================================
       GOOGLE RECAPTCHA V3
    ========================================== */

    var RECAPTCHA_SITE_KEY = '6LdFjGgsAAAAAGPymtEI8JZrHsl0NGXGySnzJHGY';

    if (typeof grecaptcha === 'undefined') {
        console.error('Google reCAPTCHA not loaded.');
        return false;
    }


    grecaptcha.ready(function () {

        grecaptcha.execute(
            RECAPTCHA_SITE_KEY,
            {
                action: 'contact_form'
            }
        ).then(function (token) {


            /* ==========================================
               AJAX FORM SUBMIT
            ========================================== */

            var dataString =
                'ctpageOrigin=' + encodeURIComponent(ctpageOrigin) +
                '&ctfldSex=' + encodeURIComponent(ctfldSex) +
                '&ctFirstName=' + encodeURIComponent(ctFirstName) +
                '&ctLastName=' + encodeURIComponent(ctLastName) +
                '&ctEmail=' + encodeURIComponent(ctEmail) +
                '&ctStdCode=' + encodeURIComponent(ctStdCode) +
                '&ctPhone=' + encodeURIComponent(ctPhone) +
                '&ctMessage=' + encodeURIComponent(ctMessage) +
                '&ctCheckPolicy=' + encodeURIComponent(ctCheckPolicy) +
                '&ctCheckConsent=' + encodeURIComponent(ctCheckConsent) +
                '&fldCountryResidense=' + encodeURIComponent(fldCountryResidense) +
                '&fldStoreCountry=' + encodeURIComponent(fldStoreCountry) +
                '&fldStoreCity=' + encodeURIComponent(fldStoreCity) +
                '&ctStoreAddress=' + encodeURIComponent(ctStoreAddress) +
                '&storeID=' + encodeURIComponent(storeID) +
                '&g-recaptcha-response=' + encodeURIComponent(token) +
                '&recaptcha_action=contact_form';


            var url =
                'https://shopify-admin.bluestar-apps.com/bhindi/api/send-contact-email.php';


            $.ajax({

                type: "POST",

                url: url,

                data: dataString,

                cache: false,

                success: function (responseStr) {

                    $('#formContainer').hide();

                    $('#thankyouContainer').show();

                    $('#contactForm').trigger('reset');

                    scollToDiv('formSectionContainer', -80);


                    if (actionFrom == '') {

                        _satellite.track('contactForm');

                        window.location.href =
                            "/pages/discover-rolex-thankyou.html";

                    } else {

                        _satellite.track('contactForm');

                    }
                },

                error: function () {

                    console.error('Contact form submission failed.');

                }

            });

        }).catch(function (error) {

            console.error('reCAPTCHA error:', error);

        });

    });


    return false;
}



// function validateContact(actionFrom = '') {

//     var ctpageOrigin = document.contactForm.pageOrigin.value;
//     var ctfldSex = document.contactForm.fldSex.value.trim();
//     var ctFirstName = document.contactForm.fldFirstName.value.trim();
//     var ctLastName = document.contactForm.fldLastName.value.trim();
//     var ctEmail = document.contactForm.fldEmail.value.trim();
//     var ctStdCode = document.contactForm.fldStdCode.value.trim();
//     var ctPhone = document.contactForm.fldPhone.value.trim();
//     var ctMessage = document.contactForm.fldMessage.value.trim();

//     var fldCountryResidense = document.contactForm.fldCountryResidense.value.trim();
//     var fldStoreCountry = document.contactForm.fldStoreCountry.value.trim();
//     var fldStoreCity = document.contactForm.fldStoreCity.value.trim();
//     var ctStoreAddress = document.contactForm.fldStoreAddress.value.trim();
//     var storeID = $('#fldStoreAddress option:selected').attr('data-store-id');

//     var ctCheckPolicy = document.contactForm.fldCheckPolicy.checked;
//     var ctCheckConsent = document.contactForm.fldUserConsent.checked;

//     validate = true;
//     errorCount = 0;

//     $('.requiredField').each(function() {
//         value = $.trim($(this).val());
//         fldID = $(this).attr('id');
//         fldDivClass = fldID+'-class';

//         if(value == '') {
//             errorCount++;
//             $('.'+fldDivClass).addClass('msgYes');
//         }else {
//             $('.'+fldDivClass).removeClass('msgYes');
//         }
//     });

//     if (ctEmail === '' || ctPhone === '') {
//         // Show error if either field is empty
//         if (ctEmail === '') {
//             $(".fldEmail-class").addClass('msgYes');
//             errorCount++;
//         } else {
//             $(".fldEmail-class").removeClass('msgYes');
//         }

//         if (ctPhone === '') {
//             $(".fldPhone-class").addClass('msgYes');
//             errorCount++;
//         } else {
//             $(".fldPhone-class").removeClass('msgYes');
//         }
//     } else {
//         // Validate email format
//         let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//         if (!emailRegex.test(ctEmail.trim())) {
//             $(".fldEmail-class").addClass('msgYes');
//             errorCount++;
//         } else {
//             $(".fldEmail-class").removeClass('msgYes');
//         }

//         // Validate phone format
//         let phoneRegex = /^[0-9()\-\s]+$/;
//         if (!phoneRegex.test(ctPhone.trim())) {
//             $(".fldPhone-class").addClass('msgYes');
//             errorCount++;
//         } else {
//             $(".fldPhone-class").removeClass('msgYes');
//         }
//     }
    
//     // Privacy Policy
//     if (!ctCheckPolicy) {                
//         $('.policyClass').show();
//         document.contactForm.fldCheckPolicy.focus();
//         errorCount++;
//     }else {
//         $('.policyClass').hide();
//     }

//     // User Consent
//     if (!ctCheckConsent) {                
//         $('.consentClass').show();
//         document.contactForm.fldUserConsent.focus();
//         errorCount++;
//     }else {
//         $('.consentClass').hide();
//     }

//     if(errorCount == 0) {
//         validate = true;
//     }else {
//         validate = false;
//     }

//     if(validate == false) return false;

//     //alert(errorCount);

//     /*if (!$("#fldEmail").val().match(/^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/)) {
//         $("#fldEmail").focus();
//         valid = false;
//     }*/

//     var dataString = 'ctpageOrigin='+ ctpageOrigin + '&ctfldSex='+ ctfldSex + '&ctFirstName='+ ctFirstName + '&ctLastName='+ ctLastName + '&ctEmail='+ ctEmail + '&ctStdCode='+ ctStdCode + '&ctPhone='+ ctPhone + '&ctMessage='+ ctMessage + '&ctCheckPolicy=' + ctCheckPolicy + '&ctCheckConsent=' + ctCheckConsent  + '&fldCountryResidense='+ encodeURI(fldCountryResidense)  + '&fldStoreCountry='+ encodeURI(fldStoreCountry)  + '&fldStoreCity='+ encodeURI(fldStoreCity) + '&ctStoreAddress='+ encodeURI(ctStoreAddress) + '&storeID='+ encodeURI(storeID) + '&g-recaptcha-response=' +$('#g-recaptcha-response').val();

//     url = 'https://shopify-admin.bluestar-apps.com/bhindi/api/send-contact-email.php';

//     $.ajax({
//         type: "POST",
//         url: url,
//         data: dataString,
//         cache: false,
//         success: function(responseStr){
//             $('#formContainer').hide();    
//             $('#thankyouContainer').show();    
//             $('#contactForm').trigger('reset');
            
//             scollToDiv('formSectionContainer', -80);
            
//             if(actionFrom == '') {
//                 //window.location.href = "/pages/discover-rolex-thankyou.html"; 
//                 _satellite.track('contactForm');
//                 window.location.href = "/pages/discover-rolex-thankyou.html"; 
//             }else {
//                 _satellite.track('contactForm');
//             }
//         }
//     });
// };

function scollToDiv(pageElementName, adjustedHeight){
    //const targetDiv = document.getElementById("formSectionContainer");
    //targetDiv.scrollIntoView({ behavior: "smooth" });
    
    const targetDiv = document.getElementById(pageElementName);
    const currentScrollY = window.pageYOffset;

    const targetDivRect = targetDiv.getBoundingClientRect();
    const targetDivTop = targetDivRect.top;

    const parentDiv = targetDiv.parentElement;
    const parentScrollY = parentDiv.scrollTop || 0;  // Handle potential absence of scrollTop

    const finalScrollY = targetDivTop + currentScrollY + parentScrollY - adjustedHeight;
    //alert(finalScrollY);

    window.scrollTo({ top: finalScrollY, behavior: "smooth" });
}

function showmodelavail(){
    //$('#workingDiv').show();
    $('html, body').animate({scrollTop: $("#modalavailability").offset().top }, 500);
    //$('#workingDiv').hide();
}
function sendusmessage(){
    //$('#workingDiv').show();
    $('html, body').animate({scrollTop: $("#send-us-message").offset().top }, 600);
    //$('#workingDiv').hide();
}

function showmodelavailipad(){
    //$('#workingDiv').show();
    $('html, body').animate({scrollTop: $("#modalavailability").offset().top }, 500);
    //$('#workingDiv').hide();
}

function showContactForm() {
    $('#formContainer').show();    
    $('#thankyouContainer').hide();    
    $('#backToContactFrom').trigger('click');
}

function showmodelavail(){
    $('#workingDiv').show();
    $('html, body').animate({scrollTop: $("#modalavailability").offset().top }, 500);
    $('#workingDiv').hide();
}




let mySwiper;

document.querySelectorAll('.thumb').forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
        document.getElementById('lightboxModal').style.display = 'flex';

        if (!mySwiper) {
            mySwiper = new Swiper('.swiper', {
                loop: false,
                pagination: {
                    el: '.swiper-pagination-gallery',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next-gallery',
                    prevEl: '.swiper-button-prev-gallery',
                },
            });
        }

        mySwiper.slideTo(index, 0);
    });
});

function closeModal() {
    document.getElementById('lightboxModal').style.display = 'none';
}

document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
        closeModal();
    }
});

var galleryTop = new Swiper('.swiperMobile', {
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: '.swiper-paginationmobile',
        clickable: true,
    },

    breakpoints: {
        990: {
            slidesPerView: 1,
            slidesPerGroup: 1
        }
    },
});


$('.expand_map').click(function(){
    $('.singleLocation').toggleClass('showleftPartGrid').removeClass('showleftPart');
})

$('#viewList .viewListBtn').click(function(){
    $('#viewList').toggleClass('showviewDetail')      
})
      
document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector('[title="Expand map"]');

    if (btn) {
        btn.addEventListener("click", function () {
            if (this.getAttribute("title") === "Expand map") {
                this.setAttribute("title", "Collapse map");
            } else {
                this.setAttribute("title", "Expand map");
            }
        });
    }
});  

$('.filter-icon').click(function() {   
    $('.collection-watches .leftFilter').addClass('showLeftsection')
    $('body').addClass('scrollNone')
});

$('.collection-watches .leftFilter .closeFilter').click(function() {
    $('.leftFilter').removeClass('showLeftsection')
    $('body').removeClass('scrollNone')
});

$('.collection-watches .leftFilter .viewResult').click(function() {
    $('#workingDiv').show();
    $('.leftFilter').removeClass('showLeftsection')
    $('body').removeClass('scrollNone')
    setTimeout(function() {
        $("html, body").animate({
        scrollTop: $("#collection_main_container").offset().top
        }, "slow");
    }, 500);

    $('#workingDiv').hide();
});      
    